var map = {
	"./africa": 579,
	"./africa.js": 579,
	"./australia": 668,
	"./australia.js": 668,
	"./bangladesh": 669,
	"./bangladesh.js": 669,
	"./global": 670,
	"./global.js": 670,
	"./india": 671,
	"./india.js": 671,
	"./newzealand": 672,
	"./newzealand.js": 672,
	"./pakistan": 673,
	"./pakistan.js": 673,
	"./srilanka": 674,
	"./srilanka.js": 674,
	"./taboola": 666,
	"./taboola.js": 666,
	"./unitedkingdom": 675,
	"./unitedkingdom.js": 675,
	"./unitedstates": 676,
	"./unitedstates.js": 676
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 578;



//////////////////
// WEBPACK FOOTER
// ../app/lib/utils/editions/config/cricinfo ^\.\/.*$
// module id = 578
// module chunks = 0